/** Largest QR we draw: past this it stops gaining scannability and just eats screen. */
const MAX_QR_PX = 350;

/** Breathing room for the screen's own padding, so the code is never flush to the edge. */
const VIEWPORT_MARGIN_PX = 40;

/** Fallback for the server/test render, where there is no viewport to measure. */
const FALLBACK_QR_PX = 300;

/**
 * TEC-204: how wide to draw a QR on this screen.
 *
 * `qr-code` renders a bitmap at exactly the `size` it is given, so a hard-coded
 * one overflows the moment the viewport is narrower than it — which is what
 * Android's display-size setting and iOS's Display Zoom both do (QA hit it on
 * the driver's "Vender boleto" at maximum zoom). Downscaling the bitmap in CSS
 * would fit it, but blurs the module edges the scanner reads, so the size has
 * to be right when it is drawn.
 *
 * Deliberately not text-scaled: a QR is a target for a camera, not something
 * anyone reads, so it takes the width it needs and no more.
 */
export function viewportQrSize(): number {
  if (typeof window === 'undefined') return FALLBACK_QR_PX;
  return Math.min(window.innerWidth - VIEWPORT_MARGIN_PX, MAX_QR_PX);
}
